module.exports = __webpack_public_path__ + "media/images/promo/akt/akt_hr_monitor-e8567008792d4027689683002f02948d.png";